import { makeStyles } from 'tss-react/mui';

import { backdropClasses } from '@mui/material';

export default makeStyles({ name: 'CookieConsentBanner' })({
    root: {
        [`.${backdropClasses.root}`]: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            backdropFilter: 'blur(8px)'
        }
    },
    paper: {
        maxWidth: 480,
        boxSizing: 'border-box',
        padding: 24,
        borderRadius: 16,
        background: 'rgba(8, 8, 10, 0.75)',
        backdropFilter: 'blur(5px)'
    },
    title: {
        margin: 0,
        color: '#fff',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '-0.32px'
    },
    description: {
        marginTop: 8,
        marginBottom: 24,
        color: '#AEB0B1',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.26px',
        a: {
            color: '#AEB0B1 !important',
            textDecoration: 'underline'
        }
    },
    buttons: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    accept: {
        height: 32,
        padding: '8px 16px',
        borderRadius: 96,
        background: '#fff !important',
        color: '#010A21',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '16px'
    },
    reject: {
        height: 32,
        padding: '7px 15px',
        borderRadius: 96,
        border: '1px solid #E0E2DF !important',
        color: '#fff',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    }
});
